import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconOutlinedFlag } from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { buttonResetStyles } from '@change-corgi/design-system-legacy/reset';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { ReportAbuseLink } from 'src/app/shared/components/abuse';

import { usePetitionDetails } from '../hooks/petitionDetails';

export function ReportAbuseContainer(): JSX.Element | null {
	const { id, slug } = usePetitionDetails();
	const isSunriseThemeEnabled = useIsSunriseTheme();

	return (
		<Box pt={24} data-qa="report-abuse-section">
			<ReportAbuseLink type="petition" petitionId={id} petitionSlug={slug}>
				<button type="button" sx={{ ...buttonResetStyles, display: 'flex', alignItems: 'center' }}>
					<Icon
						icon={iconOutlinedFlag}
						{...(isSunriseThemeEnabled
							? {
									size: 'l',
									color: 'sunrise.semantic.typography.strong',
								}
							: {
									size: 's',
									color: 'typography-secondary',
								})}
						mr={8}
					/>
					<Text
						{...(isSunriseThemeEnabled
							? {
									size: 'small',
									color: 'sunrise.semantic.typography.strong',
								}
							: {
									size: 'caption',
									color: 'typography-secondary',
								})}
						sx={{ textDecoration: 'underline' }}
					>
						<Translate value="fe.components.petition_report_abuse.report_link" />
					</Text>
				</button>
			</ReportAbuseLink>
		</Box>
	);
}
